import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { initializeRealUserMonitoring } from '@eb/real-user-monitoring';

import PageRoutes from './pages/PageRoutes';

const queryClient = new QueryClient({
    defaultConfig: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

const isProd = ({ env }) => {
    return env.ebDomain.indexOf('eventbrite') > -1;
};

export default class DiscoverApp extends React.Component {
    componentDidMount() {
        if (isProd(this.props)) {
            initializeRealUserMonitoring({
                sampleRate: 15,
                version: this.props.app_version,
                service: this.props.app_name,
            });
        }
    }

    render() {
        return (
            <QueryClientProvider client={queryClient}>
                <PageRoutes {...this.props} />
            </QueryClientProvider>
        );
    }
}
